import { Box, Stack, Typography, Chip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import {
  MapOutlined,
  AccountTreeOutlined,
  HubOutlined,
  SettingsEthernetOutlined,
  RouterOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import WidgetCard from "./WidgetCard";
import { timeAgo } from "./utils";

const TIPO_META = {
  0: { label: "Geolocalização", route: "geo", icon: <MapOutlined /> },
  1: { label: "Topologia", route: "top", icon: <AccountTreeOutlined /> },
  2: { label: "POP", route: "top", icon: <HubOutlined /> },
  3: { label: "FTTH", route: "onus", icon: <SettingsEthernetOutlined /> },
  4: { label: "Ping", route: "ping", icon: <RouterOutlined /> },
};

function tipoColor(theme, tipo) {
  switch (tipo) {
    case 0:
      return theme.palette.primary.main;
    case 1:
      return theme.palette.secondary.main;
    case 2:
      return theme.palette.warning.main;
    case 3:
      return theme.palette.info.main;
    default:
      return theme.palette.sucess?.main || theme.palette.success.main;
  }
}

export default function MapsWidget({ recentMaps = [], loading = false }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const list = recentMaps;

  const rowStyle = (color) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    px: 1,
    py: 0.85,
    borderRadius: 1,
    cursor: "pointer",
    transition: "background-color .15s ease",
    "&:hover": { backgroundColor: alpha(color, 0.08) },
  });

  return (
    <WidgetCard
      title="EasyMaps"
      icon={<MapOutlined fontSize="small" />}
      accent={"#E94159"}
      ctaLabel="Ver mapas"
      onCta={() => navigate("/easyMaps")}
      loading={loading}
      empty={!loading && list.length === 0}
      emptyLabel="Você ainda não abriu nenhum mapa recentemente."
    >
      {list.map((map) => {
        const meta = TIPO_META[map.tipo] || TIPO_META[0];
        const color = tipoColor(theme, map.tipo);
        return (
          <Box
            key={map.id}
            sx={rowStyle(color)}
            onClick={() => navigate(`/easyMaps/mapa/${meta.route}/${map.id}`)}
            onMouseDown={(e) => {
              if (e.button === 1)
                window.open(
                  `${window.location.origin}/easyMaps/mapa/${meta.route}/${map.id}`,
                  "_blank",
                );
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1.5,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color,
                backgroundColor: alpha(color, 0.12),
                "& svg": { fontSize: 18 },
              }}
            >
              {meta.icon}
            </Box>
            <Box sx={{ minWidth: 0, flexGrow: 1 }}>
              <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }} noWrap>
                {map.titulo}
              </Typography>
              <Stack direction="row" alignItems="center" gap={0.75}>
                <Chip
                  label={meta.label}
                  size="small"
                  sx={{
                    height: 18,
                    fontSize: "0.65rem",
                    color,
                    backgroundColor: alpha(color, 0.12),
                  }}
                />
                {map.lastOpenedAt && (
                  <Typography
                    sx={{
                      fontSize: "0.72rem",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {timeAgo(map.lastOpenedAt)}
                  </Typography>
                )}
              </Stack>
            </Box>
          </Box>
        );
      })}
    </WidgetCard>
  );
}
